// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".indent[data-v-40a7132a] {\n  padding-left: 48px;\n}\n.quantity-col[data-v-40a7132a] {\n  width: 513px;\n}\n.delete-col[data-v-40a7132a] {\n  width: 59px;\n}\n.product-type[data-v-40a7132a] {\n  font-size: 12px;\n  line-height: 16px;\n  color: #4e5a6a;\n  margin-top: 6px;\n}\n", ""]);
// Exports
module.exports = exports;
